import clsx from "clsx";
import {
    ArrowUpIcon,
    ArrowDownIcon,
    MinusIcon,
} from "@heroicons/react/20/solid";

interface DeltaIndicatorProps {
    delta: number | null;
    className?: string;
}

export function DeltaIndicator({ delta, className }: DeltaIndicatorProps) {
    if (delta === null || !Number.isFinite(delta)) {
        return <span className={clsx("body-s subdued", className)}>-</span>;
    }

    const changePercent = delta * 100;
    const isPositive = delta > 0;
    const isNegative = delta < 0;
    const isNeutral = delta === 0;

    return (
        <span
            className={clsx(
                "body-s flex items-center gap-1",
                isPositive && "text-green-400",
                isNegative && "text-red-400",
                isNeutral && "text-gray-400",
                className,
            )}
        >
            {changePercent.toFixed(1)}%
            {isPositive && <ArrowUpIcon className="size-4 fill-green-400" />}
            {isNegative && <ArrowDownIcon className="size-4 fill-red-400" />}
            {isNeutral && <MinusIcon className="size-4 stroke-gray-400" />}
        </span>
    );
}
